import { Box, Button, Typography } from "@mui/material";
import SuccessIcon from "assets/icons/Success";
import { EPath } from "constants/path";
import { useNavigate } from "react-router";
import { buttonVariants } from "utils/muiTailwindStyles";

function ResetPasswordSuccessfully() {
  const navigate = useNavigate();
  return (
    <Box className="p-16 max-w-[552px] border bg-white rounded-xl space-y-6 border-color_E8E8E9 border-1">
      <Box className="text-center space-y-6">
        <Typography
          variant="h5"
          component="h5"
          className="text-[22px] leading-7 text-surface-dark"
        >
          Password Reset Successfully
        </Typography>

        <Typography variant="body2" className="text-black text-base px-4">
          You can use your new password to log in to Cellera.
        </Typography>

        <SuccessIcon />

        <Button
          type="submit"
          variant="contained"
          className="w-full h-14 font-medium rounded-[100px] text-white"
          sx={{
            ...buttonVariants.primary.sx,
            fontSize: "16px",
          }}
          onClick={() => navigate(EPath.LOGIN)}
        >
          Back to Log In
        </Button>
      </Box>
    </Box>
  );
}

export default ResetPasswordSuccessfully;
